// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__14-Zj","alertIcon":"ConfirmModal_alertIcon__1Eb3y"};